export type FontSizeScale = "normal" | "large" | "xlarge";

export const FONT_SIZE_STORAGE_KEY = "demo_font_size";

export const FONT_SIZE_LABELS: Record<FontSizeScale, { name: string; size: string; desc: string }> = {
  normal: { name: "ปกติ", size: "16px", desc: "ขนาดมาตรฐาน" },
  large: { name: "ใหญ่", size: "18px", desc: "อ่านง่าย สบายตา" },
  xlarge: { name: "ใหญ่พิเศษ", size: "20px", desc: "ตัวหนังสือขนาดใหญ่พิเศษ" },
};

export function getSavedFontSize(): FontSizeScale {
  if (typeof window === "undefined") return "normal";
  const saved = localStorage.getItem(FONT_SIZE_STORAGE_KEY) as FontSizeScale | null;
  if (saved === "normal" || saved === "large" || saved === "xlarge") {
    return saved;
  }
  return "normal";
}

export function applyFontSize(size: FontSizeScale) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-font-size", size);
  if (typeof window !== "undefined") {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, size);
  }
}

export function initFontSize(defaultFromServer?: string) {
  if (typeof document === "undefined") return;
  const saved = typeof window !== "undefined" ? (localStorage.getItem(FONT_SIZE_STORAGE_KEY) as FontSizeScale | null) : null;
  const validServer = defaultFromServer === "normal" || defaultFromServer === "large" || defaultFromServer === "xlarge" ? defaultFromServer : null;
  const size: FontSizeScale = saved || validServer || "normal";
  applyFontSize(size);
}
